var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasFields)?_c('div',[_c('vs-col',{staticStyle:{"padding":"5px"}},[_c('vs-row',[_vm._v("Fields configured:")])],1),_vm._l((_vm.configuredFields),function(field,index){return _c('Field',{key:index,attrs:{"fieldInitState":field},on:{"configuredFieldUpdated":params => _vm.updateConfiguredField(params)}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }